import React,{useEffect,useMemo,useState}from'react';

const navigation=[
 {section:'',items:[
  {id:'overview',label:'Visão Geral',description:'Resumo da operação e acessos rápidos',icon:'⌂',kind:'home'},
 ]},
 {section:'INTELIGÊNCIA',items:[
  {id:'market-intelligence',label:'Visão de Mercado',description:'Categorias, tendências e oportunidades',icon:'◫',center:'Intelligence',port:5213},
  {id:'product-opportunities',label:'Produtos & Oportunidades',description:'Radar, catálogo e descoberta comercial',icon:'◇',center:'Commerce',port:5210},
  {id:'competition',label:'Concorrência',description:'Concorrentes, sellers e inteligência competitiva',icon:'◎',center:'Intelligence',port:5213},
 ]},
 {section:'OPERAÇÕES',items:[
  {id:'commerce',label:'Produtos & Anúncios',description:'Produtos, publisher, pedidos e operação',icon:'▦',center:'Commerce',port:5210},
  {id:'automation',label:'Automações',description:'Workflows, decisões e rotinas operacionais',icon:'↻',center:'Automation',port:5212},
 ]},
 {section:'IA',items:[
  {id:'copilot',label:'AQENORA Copilot',description:'IA aplicada aos dados e à operação',icon:'✦',center:'AI Studio',port:5211},
  {id:'agents',label:'Agentes',description:'Agentes, workflows e autonomia supervisionada',icon:'◉',center:'Automation',port:5212},
 ]},
 {section:'ANÁLISES',items:[
  {id:'executive',label:'Executive Intelligence',description:'Cockpit, P&L, forecasting e indicadores',icon:'▤',center:'Intelligence',port:5213},
 ]},
 {section:'PLATAFORMA',items:[
  {id:'platform',label:'Integrações & Governança',description:'Conectores, segurança, operações e documentação',icon:'⚙',center:'Platform',port:5214},
 ]},
];

function moduleUrl(port,tenant,actor){
 const q=new URLSearchParams({tenant_id:tenant||'',actor_id:actor||''});
 const path=port===5210?'/modules/commerce/':port===5214?'/modules/platform/':port===5211?'/modules/ai/':port===5212?'/modules/automation/':port===5213?'/modules/intelligence/':`/modules/unknown/`;
 return `${path}?${q}`;
}

const modulesEnabled=import.meta.env.VITE_MODULES_ENABLED==='true'||import.meta.env.VITE_MODULES_ENABLED===undefined;

function Overview({onNavigate}){
 const cards=[
  ['Visão de Mercado','Explore categorias, tendências e oportunidades comerciais.','market-intelligence'],
  ['Produtos & Oportunidades','Acesse radar, catálogo, anúncios e inteligência de produto.','product-opportunities'],
  ['AQENORA Copilot','Use IA para interpretar dados e apoiar decisões operacionais.','copilot'],
  ['Automações & Agentes','Crie rotinas, workflows e agentes supervisionados.','agents'],
 ];
 return <div className="overview">
  <div className="overviewHero">
   <div>
    <span className="eyebrow">COMMERCIAL EXPERIENCE 8.3.0-A</span>
    <h1>Central de operação e inteligência</h1>
    <p>AQENORA reúne inteligência comercial, operação multicanal, IA e automação em uma experiência única e preparada para evolução dos próximos módulos.</p>
   </div>
   <div className="heroBadge"><span>●</span><div><strong>Ambiente operacional</strong><small>Base comercial unificada</small></div></div>
  </div>
  <section className="overviewSection">
   <div className="sectionHeading"><div><h2>Acesso rápido</h2><p>Entre diretamente nas áreas principais da plataforma.</p></div></div>
   <div className="quickGrid">{cards.map(([title,desc,id])=><button key={id} className="quickCard" onClick={()=>onNavigate(id)}>
    <span className="quickArrow">↗</span><strong>{title}</strong><p>{desc}</p>
   </button>)}</div>
  </section>
  <section className="overviewSection">
   <div className="sectionHeading"><div><h2>Estrutura comercial</h2><p>Fundação visual preparada para Product Discovery, Category Intelligence, Competitor Intelligence, Supplier Intelligence e Marketplace Health.</p></div></div>
   <div className="foundationStrip">
    <div><span>01</span><strong>Descobrir</strong><small>Mercado e oportunidades</small></div>
    <div><span>02</span><strong>Analisar</strong><small>Produto e concorrência</small></div>
    <div><span>03</span><strong>Operar</strong><small>Anúncios e marketplaces</small></div>
    <div><span>04</span><strong>Automatizar</strong><small>IA, agentes e workflows</small></div>
   </div>
  </section>
 </div>;
}

export default function UnifiedShell({user,onLogout}){
 const[active,setActive]=useState('overview');
 const[tenant,setTenant]=useState(()=>localStorage.getItem('promptforge.tenant_id')||'');
 const actor=user?.sub||user?.id||user?.email||'local-user';
 const items=useMemo(()=>navigation.flatMap(g=>g.items),[]);
 const current=items.find(x=>x.id===active)||items[0];
 useEffect(()=>{if(tenant)localStorage.setItem('promptforge.tenant_id',tenant)},[tenant]);

 return <div className="appShell">
  <header className="topbar">
   <div className="brand"><span className="brandMark">A</span><div><strong>AQENORA</strong><small>Commerce Intelligence Platform</small></div></div>
   <div className="workspace"><label>Workspace<input value={tenant} onChange={e=>setTenant(e.target.value)} placeholder="Selecione o tenant"/></label></div>
   <div className="account"><div className="accountIdentity"><strong>{user?.name||user?.email||'Usuário'}</strong><small>Conta conectada</small></div><button className="btn" onClick={onLogout}>Sair</button></div>
  </header>
  <div className="shellBody">
   <aside className="sidebar">
    <div className="sidebarWorkspace"><span className="statusDot"/><div><strong>AQENORA Workspace</strong><small>{tenant||'Nenhum tenant selecionado'}</small></div></div>
    <nav>{navigation.map((group,idx)=><div className="navGroup" key={group.section||idx}>
     {group.section&&<div className="sidebarTitle">{group.section}</div>}
     {group.items.map(x=><button key={x.id} className={active===x.id?'active':''} onClick={()=>setActive(x.id)} title={x.description}>
      <span className="navIcon">{x.icon}</span><span className="navCopy"><strong>{x.label}</strong><small>{x.description}</small></span>
     </button>)}
    </div>)}</nav>
    <div className="sidebarFooter"><strong>AQENORA 8.3.0-A</strong><small>Commercial UX Foundation</small></div>
   </aside>
   <main className="content">
    {active==='overview'
      ? <Overview onNavigate={setActive}/>
      : !tenant
       ? <div className="tenantWarning"><span className="eyebrow">WORKSPACE NECESSÁRIO</span><h2>Selecione um Workspace</h2><p>O Tenant ID define o contexto comercial da sessão. Informe um tenant criado no Owner Console para abrir {current.label}.</p></div>
       : <div className="moduleSurface"><div className="moduleHeader"><div><span className="eyebrow">{current.center}</span><h2>{current.label}</h2></div><span className="moduleStatus">{modulesEnabled?'Conectado':'Não publicado'}</span></div>{modulesEnabled?<iframe title={current.label} className="moduleFrame" src={moduleUrl(current.port,tenant,actor)}/>:<div className="moduleUnavailable"><strong>Este módulo ainda não está publicado neste ambiente.</strong><p>A autenticação, o workspace e os serviços centrais estão ativos. A interface de {current.label} depende do deployment do módulo correspondente e será habilitada em uma próxima etapa.</p></div>}</div>
    }
   </main>
  </div>
 </div>;
}
